import { AfterViewInit, Component, HostListener, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { fabric } from 'fabric';
import { Canvas, Group, Object, IText, Point } from 'fabric/fabric-impl';
;

import { MapUtilService } from '../services/map-util.service';
import Swal, { SweetAlertOptions } from 'sweetalert2';

import { StorageUtil } from '../utils/storage.util';
import { MarinaBerthMap } from '../models/marina-berth-map';
import { ToastService } from '../services/toast.service';
import { VacancyService } from '../services/vacancy.service';
import { VacancyMapDTO } from '../models/dtos/vacancy-mapDTO';
import { MovementLocationService } from '../services/movements/movement-location.service';
import { MovementLocation } from '../models/movement/movement-location';
import { Vacancy } from '../models/vacancy';
import { Boat } from '../models';
import { VacancyStatusDTO } from '../models/dtos/vacancy-statusDTO';
import { BoatService } from '../services/boat.service';
import { BoatDTO } from '../models/dtos/boatDTO';
import { DialogService } from 'primeng/dynamicdialog';
import { BerthMapInfoFormComponent } from './info-form/berth-map-info-form.component';
import { BerthMapVacancyFormComponent } from './vacancy-form/berth-map-vacancy-form.component';
import { BerthMapSelectBoatComponent } from './boat-form/berth-map-select-boat.component';
import { BerthMapNavigationPlanComponent } from './berth-map-navigation-plan/berth-map-navigation-plan.component';
import { resolveLocationFinish } from './berth-map-finish-location';
import { MovementExecutionService } from '../services/movements/movement-execution.service';
import { OperationalConfigService } from '../services/config/operational-config.service';
import { MovementLocationType } from '../models/enums/movements/movement-location-type';
import { FilterBoatMovement } from '../models/dtos/movements/filter-boat-movement';
import { ExecuteOperationDTO } from '../models/dtos/movements/execute-operationDTO';
import { MovementOperation } from '../models/enums/movements/movement-operation';
import { MovementPlanService } from '../services/movements/movement-plan.service';
import { MovementStatus } from '../models/enums/movements/movement-status';
import { findOpenPlanOfDay, OPEN_PLAN_TODAY } from './berth-map-open-plan';
import { NavigationPlanResult } from './berth-map-navigation-plan/berth-map-navigation-plan.component';
import { switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';

/** Retorno que o mapa não consegue apontar sozinho (fora da fila de hoje ou destino a escolher). */
export const RETURN_NOT_FOUND =
  'Retorno não encontrado na fila de movimentação de hoje. Conclua pela tela de Movimentação.';

/** Mais de uma etapa de retorno do barco na fila: o mapa não escolhe por ele. */
export const RETURN_AMBIGUOUS =
  'Há mais de um retorno pendente para esta embarcação. Conclua pela tela de Movimentação.';

/** O menu foi aberto com uma situação que já não vale (status mudou ou menu de outra vaga). */
export const BERTH_STATE_CHANGED = 'A situação da vaga mudou. Atualize o mapa e tente de novo.';

/** Etapa que traz o barco da navegação de volta: ainda não iniciada, com o barco na navegação. */
const RETURN_STEP_STATUSES: string[] = [MovementStatus.AWAITING_PREPARATION, MovementStatus.PREPARED];

@Component({
  selector: 'app-berth-map',
  templateUrl: './berth-map.component.html',
  styleUrls: ['./berth-map.component.css']
})
export class BerthMapComponent implements OnInit,OnDestroy,AfterViewInit {

  @ViewChild('canvasContainer', { static: false }) 
  canvasContainer!: ElementRef;

  resizeObserver: ResizeObserver | undefined;


  title = 'context-menu';

  isDisplayBerthContextMenu: boolean;
  rightClickMenuPositionX: number;
  rightClickMenuPositionY: number;
  rightClickedFabricObj: Object;
  b_map: MarinaBerthMap;
  absoluteClickedPoint?: Point;
  vacancyStatusDTOList: VacancyStatusDTO[];
  isDisplayMenuMap: boolean;
  _canvas: Canvas;
  refreshButtonDisabled: boolean;
  saveButtonDisabled: boolean;


  public editModes : any[];
  public selectedEditMode: string;
  /** Apontar navegação/retorno só existe para marina com movimentação (operational_config.enable_movements). */
  movementsEnabled = false;

  constructor(private mapUtilService: MapUtilService,
              private toasty:ToastService,
              private vacancyService: VacancyService,
              private movementLocationService: MovementLocationService,
              private boatService: BoatService,
              private dialog: DialogService,
              private movementExecutionService: MovementExecutionService,
              private operationalConfigService: OperationalConfigService,
              private movementPlanService: MovementPlanService) {
    this.editModes = [
      {label: 'Editar',icon: 'pi pi-pencil',value: 'ED'},
      {label: 'Operar', icon: 'pi pi-cog',value: 'OP'},
      {label: 'Ver', icon: 'pi pi-eye', value: 'RO'}

    ]
  }


  ngOnInit(): void {
    // Estado inicial da barra antes da 1ª checagem da view (no ngAfterViewInit dava NG0100 em modo dev).
    this.selectedEditMode = 'RO';
    this.refreshButtonDisabled = false;
    this.saveButtonDisabled = true;
    this.operationalConfigService.isMovements()
      .then((enabled) => this.movementsEnabled = !!enabled)
      .catch(() => this.movementsEnabled = false);
  }



  ngAfterViewInit() {
     

      this._canvas = new fabric.Canvas("canvas");
      this.mapUtilService.canvas = this._canvas;
      this.mapUtilService.canvasContainer = this.canvasContainer;
      this.mapUtilService.initCanvas();



    this._canvas.on("mouse:down",(evt) => {
       this.absoluteClickedPoint  = evt.absolutePointer;
       if (evt.target) {
           let fabricObj:Object = evt.target;
           console.log(fabricObj);
           if (evt.button == 3 &&  fabricObj && ( (fabricObj.type == 'rect') || (fabricObj.get('type') == 'group' && fabricObj['esy.type'] == 'boat_icon') ) ) {  
              this.displayContextMenu(evt.e,fabricObj);
            
           }
          } else {
            if (evt.button == 3 ) {
              this.displayContextMApMenu(evt.e,evt.target);
            }
          }
        }

    );

    this.observeResize();
    
  }


  displayContextMApMenu(event,fabricObj:Object) {
    this.isDisplayMenuMap = true;
      this.rightClickMenuPositionX = event.clientX;
      this.rightClickMenuPositionY = event.clientY;

  }

  editModeChange(evt:any) {
    if(this.selectedEditMode == 'ED') {
      this.mapUtilService.unlockAllObjects();
      this.mapUtilService.clearOperationInfo();
      this.refreshButtonDisabled = true;
      this.saveButtonDisabled = false;
    }
    if(this.selectedEditMode == 'OP' || this.selectedEditMode == 'RO') {
      this.mapUtilService.lockAllObjects();
      this.reloadStatus();
      this.refreshButtonDisabled = false;
      this.saveButtonDisabled = true;
    } 
  }


  displayContextMenu(event,fabricObj:Object) {
    console.log(fabricObj);  
    this.isDisplayBerthContextMenu = true;
    if (fabricObj['esy.type'] == 'boat_icon' ) {
      this.rightClickedFabricObj = this.mapUtilService.findBerthObjectByVacancyId(fabricObj['esy.berthId']);
    } else {
      this.rightClickedFabricObj = fabricObj;
    }
    
    this.rightClickMenuPositionX = event.clientX;
    this.rightClickMenuPositionY = event.clientY;

  }

  getRightClickMenuStyle() {
    return {
      position: 'fixed',
      left: `${this.rightClickMenuPositionX}px`,
      top: `${this.rightClickMenuPositionY}px`
    }
  }

  async handleBerthContextMenuClick(event) {
   console.log(event.event.altKey); 
   switch (event.data.action) {
      case 'clone-right':
        let pointR = this.mapUtilService.getPointForBerthClone(this.rightClickedFabricObj,'right');
        if (event.event.altKey) {
          this.alocateExistingVacancy(pointR.y,pointR.x,this.rightClickedFabricObj.angle);
        } else {
          this.newVacancy(pointR.y,pointR.x,this.rightClickedFabricObj.angle);
        }
        break;
      case 'clone-left':
        let pointL = this.mapUtilService.getPointForBerthClone(this.rightClickedFabricObj,'left');
        if (event.event.altKey) {
          this.alocateExistingVacancy(pointL.y,pointL.x,this.rightClickedFabricObj.angle);
        } else {
          this.newVacancy(pointL.y,pointL.x,this.rightClickedFabricObj.angle);  
        }
        break;
      case 'delete':
        this.mapUtilService.deleteBerthOnMap(this.rightClickedFabricObj);
        break;
      case 'change':
        await this.updateVacancy(this.rightClickedFabricObj);
        break;

      case 'info':
        this.openInfoDialog();   
    }
  }

  async handleBerthOperationMenuClick(event) {
    switch (event.data.action) {
      case 'navigation':
        if (!this.canStartNavigation(this.rightClickedFabricObj)) {
          this.toasty.warning(BERTH_STATE_CHANGED);
          break;
        }
        this.openNavigationPlanDialog(this.rightClickedFabricObj);
        break;
      case 'nav-return':
        if (!this.canReturn(this.rightClickedFabricObj)) {
          this.toasty.warning(BERTH_STATE_CHANGED);
          break;
        }
        this.finishNavigation(this.rightClickedFabricObj);
        break;
      case 'moored':
        this.mapUtilService.addBoatIcon(this.rightClickedFabricObj,"recones/Lancha-4.svg");
        break;
      case 'return-delayed':
        this.mapUtilService.changeBerthColor(this.rightClickedFabricObj,this.mapUtilService.colors.return_delayed);
        break;  
      case 'set-boat':
        await this.selectBoatForVacancy(this.rightClickedFabricObj);
        break;
      case 'info':
        this.openInfoDialog();
        break;
      case 'unset-boat':
        if ( this.rightClickedFabricObj['esy.boatId'] &&  this.rightClickedFabricObj['esy.berthId']) {
          let  boatId = parseInt(this.rightClickedFabricObj['esy.boatId']);
          this.vacancyService.unsetBoat(boatId).subscribe(
            (r) => {},
            (err) => {
              this.toasty.error("Erro ao desvincular emnbarcação á vaga.");
            },
            () => { 
              this.rightClickedFabricObj['esy.boatId'] = null;
              this.toasty.success("Embarcação devinculada com sucesso!");
              this.reloadStatus();
              this.mapUtilService.saveMap();
            }
          );
        }
       
        break;



    }



  }

  /** "Alocar Embarcação": escolhe entre os barcos ativos sem vaga e vincula à vaga clicada. */
  private async selectBoatForVacancy(berthObj: Object) {
    let boats: BoatDTO[];
    try {
      boats = await this.boatService.getActiveNoVacancy().toPromise();
    } catch (e) {
      this.toasty.error('Não foi possível carregar as embarcações sem vaga.');
      return;
    }
    this.dialog.open(BerthMapSelectBoatComponent, {
      header: 'Vincular Embarcação',
      width: '450px',
      data: { boats: boats || [] }
    }).onClose.subscribe((boat: BoatDTO) => {
      if (!boat || !boat.id) {
        return;
      }
      const vacancyId = berthObj['esy.berthId'];
      this.vacancyService.setBoat(vacancyId, boat.id).subscribe({
        error: () => this.toasty.error("Erro ao vincular emnbarcação á vaga."),
        complete: () => {
          berthObj['esy.boatId'] = boat.id;
          this.toasty.success("Embarcação vinculada com sucesso!");
          this.reloadStatus();
          this.mapUtilService.saveMap();
        }
      });
    });
  }

  /** "Apontar Retorno": finaliza a etapa navegação → vaga do barco que está na fila de hoje. */
  finishNavigation(berthObj: Object) {
    const boatId = Number(berthObj['esy.boatId']);
    if (!boatId) {
      return;
    }
    Swal.fire({
      text: 'Finalizar navegação do barco ' + (berthObj['esy.boatName'] || '') + '?',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((isConfirm) => {
      if (!isConfirm.value) {
        return;
      }
      const filter: FilterBoatMovement = new FilterBoatMovement();
      filter.boatId = boatId;
      let movementPlanId: number;
      let movementId: number;
      this.movementExecutionService.getAllByLocation(MovementLocationType.NAVIGATION, filter).pipe(
        switchMap((movements) => {
          // A fila de NAVIGATION também traz a SAÍDA (destino navegação, STARTED/FINISHED): só vale a etapa que tira o
          // barco da navegação (MovementExecutionQueryPort.findQueue).
          const candidates = (movements || []).filter((m) => m?.boat?.id == boatId && m.movement?.movementId
            && m.currentLocation?.type === MovementLocationType.NAVIGATION
            && m.movement.destinyLocationType !== MovementLocationType.NAVIGATION
            && RETURN_STEP_STATUSES.includes(m.movement.movementStatus));
          if (candidates.length === 0) {
            return throwError(() => new Error(RETURN_NOT_FOUND));
          }
          if (candidates.length > 1) {
            return throwError(() => new Error(RETURN_AMBIGUOUS));
          }
          const current = candidates[0];
          movementPlanId = current.movement.movementPlanId;
          movementId = current.movement.movementId;
          return this.movementExecutionService.getDestinies(movementPlanId, movementId);
        }),
        switchMap((destinies) => {
          const locationFinish = resolveLocationFinish(destinies, berthObj['esy.berthId']);
          if (!locationFinish) {
            return throwError(() => new Error(RETURN_NOT_FOUND));
          }
          const executeOperationDTO: ExecuteOperationDTO = {
            movementPlanId,
            movementId,
            operation: MovementOperation.FINISH,
            locationFinish
          };
          return this.movementExecutionService.executeOperation(executeOperationDTO);
        })
      ).subscribe({
        next: () => {
          this.toasty.success("Embarcação de volta a vaga!");
          this.reloadStatus();
        },
        error: (err) => {
          const message = err?.error?.data?.exception?.message || err?.error?.message
            || (err instanceof Error ? err.message : null);
          this.toasty.error(message || 'Não foi possível apontar o retorno.');
        }
      });
    });
  }

  /** "Apontar Navegação": abre o plano de navegação do barco da vaga, se ele não tiver plano aberto hoje. */
  private openNavigationPlanDialog(berthObj: Object): void {
    const boatId = Number(berthObj['esy.boatId']);
    findOpenPlanOfDay(this.movementPlanService, boatId).pipe(
      switchMap((openPlan) => openPlan
        ? throwError(() => new Error(OPEN_PLAN_TODAY))
        : this.boatService.getById(boatId))
    ).subscribe({
      next: (boat: Boat) => {
        if (!boat || !boat.id) {
          this.toasty.error('Embarcação não encontrada.');
          return;
        }
        this.dialog.open(BerthMapNavigationPlanComponent, {
          width: '80%',
          height: '90%',
          header: 'Plano de Navegação',
          data: { boat }
        }).onClose.subscribe((result: NavigationPlanResult) => {
          // plano criado sem a saída apontada: o menu não oferece de novo para este barco
          if (result?.planCreated && !result.navigationStarted) {
            berthObj['esy.pendingPlanBoatId'] = boatId;
          }
          this.reloadStatus();
        });
      },
      error: (err) => {
        if (err instanceof Error && err.message === OPEN_PLAN_TODAY) {
          this.toasty.warning(OPEN_PLAN_TODAY);
          return;
        }
        this.toasty.error('Não foi possível carregar a embarcação.');
      }
    });
  }

  /** Revalida no clique o que o menu mostrou (o menu pode ter sido montado para outra situação). */
  private canStartNavigation(berthObj: Object): boolean {
    const boatId = Number(berthObj?.['esy.boatId']);
    return this.movementsEnabled && !!boatId && !berthObj['esy.onNavigation']
      && berthObj['esy.pendingPlanBoatId'] != boatId;
  }

  private canReturn(berthObj: Object): boolean {
    return this.movementsEnabled && !!Number(berthObj?.['esy.boatId']) && !!berthObj['esy.onNavigation'];
  }

  private openInfoDialog() {
    if (this.vacancyStatusDTOList?.length > 0) {
      let vacancyStatus: VacancyStatusDTO = this.getStatusFromRightClicked(this.rightClickedFabricObj);
      if (vacancyStatus) {
        this.openInfoDialogForm(vacancyStatus);
      }

    }
  }

  @HostListener('document:click')
  documentClick(): void {
    this.isDisplayBerthContextMenu = false;
    this.isDisplayMenuMap = false;
  }


  async handleMenuMapClick(event) {
    let _top:number = this.absoluteClickedPoint.y;
    let _left:number = this.absoluteClickedPoint.x;
      switch (event.data.action) {
        case 'new':
          await this.newVacancy(_top, _left,0);
        break;
        case 'import':
            await this.alocateExistingVacancy(_top, _left,0);
        break;
      }
             
}


  private async alocateExistingVacancy(_top: number, _left: number,angle:number) {
    let berthMapList = this.getSimpeBerthMapList();
    let vacancies = await this.getWetVacancies();
    const vacanciesAvaiable: VacancyMapDTO[] = vacancies.filter(v => !berthMapList.some(b => b.id == v.id));
    let selectedVacancy = await Swal.fire(this.getBerthImportAlertOptions(vacanciesAvaiable, '5.5', '10'));
    if (selectedVacancy) {
      let selValue: string = selectedVacancy.value[0].toString();
      let selId = parseInt(selValue.split("|")[0]);
      let code = selValue.split("|")[1];
      this.mapUtilService.createBerthOnMap(selId, code, 5.5, 10, _top, _left,angle);
    }
  }

  private async newVacancy(_top: number, _left: number, angle: number) {
    const mvLocations = await this.getMovmentLocations();
    const ref = this.dialog.open(BerthMapVacancyFormComponent, {
      header: "Nova Vaga",
      width: '50vw',
      data: {
        x: _left,
        y: _top,
        vacancy: null,
        movementLocations: mvLocations
      }
    });

    ref.onClose.subscribe((formValues) => {
      if (!formValues) {
        return;
      }
      const berthMapWidth = parseFloat(formValues.berthMapWidth);
      const berthMapHeight = parseFloat(formValues.berthMapHeight);
      const newVacancy: Vacancy = new Vacancy();
      newVacancy.movementLocation = this.findLocation(mvLocations, formValues.movementLocation);
      newVacancy.code = formValues.code;
      newVacancy.marina = StorageUtil.getMarina();
      newVacancy.length = formValues.maxBoatLength;
      newVacancy.shared = false;
      newVacancy.active = true;

      this.vacancyService.create(newVacancy).subscribe({
        next: (v) => {
          this.mapUtilService.createBerthOnMap(v.id, v.code, berthMapWidth, berthMapHeight, _top, _left, angle);
        },
        error: (e) => {
          this.toasty.error(e?.error?.message || 'Não foi possível criar a vaga.');
        }
      });
    });
  }

  /** "Alterar": código, local e tamanho máximo vão para a vaga; largura/comprimento só redesenham a vaga no mapa. */
  private async updateVacancy(berthObj: Object) {
    let vacancy: Vacancy;
    try {
      vacancy = await this.vacancyService.getById(berthObj['esy.berthId']).toPromise();
    } catch (e) {
      vacancy = null;
    }
    if (!vacancy || !vacancy.id) {
      this.toasty.error("Vaga inexistente");
      return;
    }

    const mvLocations = await this.getMovmentLocations();
    const ref = this.dialog.open(BerthMapVacancyFormComponent, {
      header: "Alterar Vaga",
      width: '50vw',
      data: {
        berthMapWidth: this.mapUtilService.getBerthWidthInMeter(berthObj),
        berthMapHeight: this.mapUtilService.getBerthHeightInMeter(berthObj),
        vacancy: vacancy,
        movementLocations: mvLocations
      }
    });

    ref.onClose.subscribe((formValues) => {
      if (!formValues) {
        return;
      }
      const berthMapWidth = parseFloat(formValues.berthMapWidth);
      const berthMapHeight = parseFloat(formValues.berthMapHeight);

      // Só o desenho mudou: nada vai para o backend (o PUT reaplicaria o prefixo do local no código e reenviaria barcos).
      if (!formValues.vacancyChanged) {
        this.mapUtilService.changeBerthAtributes(vacancy.code, berthMapWidth, berthMapHeight, berthObj);
        return;
      }

      // Relê a vaga logo antes do PUT: barco vinculado em outra tela com o diálogo aberto não é desfeito.
      this.vacancyService.getById(vacancy.id).pipe(
        switchMap((current: Vacancy) => {
          if (!current || !current.id) {
            return throwError(() => new Error('Vaga inexistente'));
          }
          if (mvLocations && mvLocations.length > 0) {
            current.movementLocation = this.findLocation(mvLocations, formValues.movementLocation);
          }
          current.code = formValues.code;
          current.length = formValues.maxBoatLength;
          return this.vacancyService.update(current);
        })
      ).subscribe({
        next: (v) => {
          this.mapUtilService.changeBerthAtributes(v?.code || formValues.code, berthMapWidth, berthMapHeight, berthObj);
        },
        error: (e) => {
          this.toasty.error(e?.error?.message || (e instanceof Error ? e.message : null) || 'Não foi possível alterar a vaga.');
        }
      });
    });
  }

  private findLocation(locations: MovementLocation[], selected: MovementLocation): MovementLocation {
    if (!selected || selected.id == null || !locations) {
      return null;
    }
    return locations.find((l) => l.id === selected.id) || null;
  }

saveMap() {
  this.mapUtilService.saveMap();

}

addBoatImage(svg_icon:string) {
  this.mapUtilService.addBoatIcon(this.rightClickedFabricObj,  svg_icon);
}


getBerthImportAlertOptions(aviableVacancies:VacancyMapDTO[],width:string,height:string):SweetAlertOptions { 
  let selOption: string = '<select class="swal2-input" name="swal-input1" id="swal-input1">';
  aviableVacancies.forEach(element => {
    selOption += '<option value="' + element.id +'|'+ element.code  +  '">' +   element.movmentLocation + ' - ' + element.code  + '</option>'
  });
  selOption += '</select>';

  return {
    width: 350,
    title: 'Importar Vaga',
    html:
    selOption +
      '<input value="' + width + '" placeholder="largura" id="swal-input2" class="swal2-input" size="6" style="height:22px;font-size: 18px">' +
      '<input value="' + height + '" placeholder="comp" id="swal-input3" class="swal2-input" size="6" style="height:22px;font-size: 18px">',
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true,
    preConfirm: () => {
      return [
        document.getElementById('swal-input1')['value'],
        document.getElementById('swal-input2')['value'],
        document.getElementById('swal-input3')['value']
      ]
    }
  }
}

  changeColor() {
    this.mapUtilService.changeBerthColor(this.rightClickedFabricObj, "#FFCD4B");
  }

  async getWetVacancies(): Promise<VacancyMapDTO[]> {
    let vacancies: VacancyMapDTO[] = await this.vacancyService.getActivesByLocationType('WET_VACANCY').toPromise();
    return vacancies;
  }


  getSimpeBerthMapList(): any[] {
    return this._canvas.getObjects()
      .filter((o) => o['esy.type'] == 'berth' && o['esy.berthId'] != null)
      .map((o) => { return { "id": o['esy.berthId'], "code": o['esy.berthCode'] } });
  }

  

  async getMovmentLocations(): Promise<MovementLocation[]> {
    let locations: MovementLocation[] = await this.movementLocationService.getAll().toPromise();
    return locations.filter( l => l.type == 'WET_VACANCY'  );
    

  } 

  async reloadStatus() {
    this.vacancyStatusDTOList = await this.vacancyService.getWetVacanciesStatus('WET_VACANCY').toPromise();
    this.mapUtilService.updateBerthsStatus(this.vacancyStatusDTOList);
    
  }

  openInfoDialogForm( vacancyStatusDTO: VacancyStatusDTO) {
    this.dialog
    .open(BerthMapInfoFormComponent, {
      width: '900px',
      height: '600px',
      dismissableMask: false,
      data: { vacancyStatusDTO },
      header: "Informações",
    });
    
    
  }

  getStatusFromRightClicked(rightClickedObj:Object): VacancyStatusDTO {
    let filteredStatus:VacancyStatusDTO[];    
    if (this.vacancyStatusDTOList && this.vacancyStatusDTOList.length > 0) {
        filteredStatus  = this.vacancyStatusDTOList.filter(stat => {  return stat.id == rightClickedObj['esy.berthId']});   
    }      
    if (filteredStatus && filteredStatus.length > 0) {
      return filteredStatus[0];
    }  else {
      return null;
    }

  }

  resizeCanvas(): void {
    const width = this.canvasContainer.nativeElement.clientWidth;
    const height = this.canvasContainer.nativeElement.clientHeight || window.innerHeight; // fallback se altura não definida

    this._canvas.setWidth(width);
    this._canvas.setHeight(height);
    this._canvas.renderAll();
    this.mapUtilService.resetZoom(this._canvas);

  }

  observeResize(): void {
    this.resizeObserver = new ResizeObserver(() => {
      this.resizeCanvas();
    });

    // Inicie o observador na div do container
    this.resizeObserver.observe(this.canvasContainer.nativeElement);
  }

  // Limpa o observador quando o componente é destruído
  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  zoomIn() {
      this.mapUtilService.zoomIn();
  }


  zoomOut() {
    this.mapUtilService.zoomOut();
  }

  






}
